/**
 * Event labels sent to server-event for Datadog metrics/monitors (info level).
 * Failure/error events are omitted; they are sent via ServerErrorEventPlugin (metadata.error).
 */
const CRUCIAL_METRIC_EVENT_LABELS_ARR = [
  // Auth
  'login successful',
  'two factor code validation successful',
  'two factor method changed successfully',
  'two factor code resent successfully',
  // Auth – forgot password
  'forgot password page viewed',
  'forgot password form submitted',
  'forgot password email request successful',
  'forgot password confirmation redirect',
  'forgot password confirmation page viewed',
  'forgot password back to login clicked',
  // Auth – reset password
  'reset password page viewed',
  'reset password form submitted',
  'reset password successful',
  'reset password sign-in successful',
  'reset password 2fa redirect for first access',
  'reset password confirmation redirect',
  'reset password confirmation page viewed',
  'reset password go to login clicked',
  // Auth – first access
  'first access corporate page viewed',
  'first access welcome confirmed',
  'first access step transition',
  'first access password form submitted',
  'first access password created successfully',
  'first access sign-in successful',
  'first access 2fa redirect',
  'first access confirmation redirect',
  'first access confirmation page viewed',
  'first access go to home clicked',
  'first access password form shown',
  // Auth – add factors
  'add factors factor added',
  'add factors journey started',
  'add factors journey completed',
  // Recarding
  'employee sheet recarding shipment created successfully',
  'employee manual recarding shipment created successfully',
  'corporate sheet recarding shipment created successfully',
  'corporate manual recarding shipment created successfully',
  // Cards
  'employee sheet cards request completed successfully',
  'employee manual cards request completed successfully',
  'corporate single cards request completed successfully',
  'corporate sheet cards request completed successfully',
  // Orders
  'order create initiated',
  'order created',
  'order sheet uploaded',
  'order sheet upload step started',
  'order sheet custom downloaded',
  'order sheet map step started',
  'order sheet map updated',
  'order detached data setted',
  'order item credit value updated',
  'order item canceled',
  'order group credit date updated',
  'order group cancel order',
  'order group export csv',
  'order group export xlsx',
  'order group export pdf',
  // Employees
  'employee create by sheet success',
  'employee create by sheet initiated',
  'employee create manual success',
  'employee create manual initiated',
  'employee edited',
  'employee list export to pdf',
  'employee list export to csv',
  'employee list export to xlsx',
  // Survey
  'recarding preference survey answer submission successful',
  // Branches
  'branches create submitted',
  'branches edit submitted',
  'branches delete confirmed',
  // Groups
  'create group page viewed',
  'group creation started',
  'group creation completed',
  'group edit page viewed',
  'group update started',
  'group update completed',
  // Swile-credit
  'swile credit page viewed',
  'swile credit report export started',
  // Configs
  'configs page viewed',
  'configs save successful'
] as const

export const CRUCIAL_METRIC_EVENT_LABELS = new Set<string>(
  CRUCIAL_METRIC_EVENT_LABELS_ARR
)

export function isMetricEventLabel(label: string): boolean {
  return CRUCIAL_METRIC_EVENT_LABELS.has(label)
}
